import { Button, Typography, useTheme } from '@mui/material';
import { Stack } from '@mui/system';
import { FC, useEffect, useState } from 'react';
import { Answer } from '../../../types';

type TriviaAnswersGridProps = {
  answers: Answer[];
  onSelectAnswer: (answerIdx: number) => void;
};

export const TriviaAnswersGrid: FC<TriviaAnswersGridProps> = ({
  answers,
  onSelectAnswer,
}): JSX.Element => {
  const [selectedIdx, setSelectedIdx] = useState<number>(-1);

  const resetIndex = () => {
    setSelectedIdx(-1);
  };

  useEffect(resetIndex, [answers]);

  const selectAnswer = (answerIdx: number) => {
    onSelectAnswer(answerIdx);
    setSelectedIdx(answerIdx);
  };

  return (
    <Stack gap={4}>
      {answers.map((answer, idx) => (
        <TriviaAnswersElement
          key={idx}
          text={answer.answer}
          onClick={() => selectAnswer(idx)}
          selected={idx === selectedIdx}
        />
      ))}
    </Stack>
  );
};

type TriviaAnswersElementProps = {
  text: string;
  selected?: boolean;
  onClick: () => void;
};

const TriviaAnswersElement: FC<TriviaAnswersElementProps> = ({
  text,
  selected = false,
  onClick,
}): JSX.Element => {
  const theme = useTheme();
  
  return (
    <Button
      variant='outlined'
      color='secondary'
      onClick={onClick}
      sx={{
        border: selected ? '1px solid' : '',
        backgroundColor: selected 
          ? theme.palette.mode === 'dark' 
            ? 'rgba(30, 135, 140, 0.2)'  // Verde transparente para modo oscuro
            : '#e3edeb'                   // Color claro para modo claro
          : '',
      }}
    >
      <Typography
        width='100%'
        textAlign='left'
        px='32px'
        color={theme.palette.mode === 'dark' ? theme.palette.secondary.main : 'black'}
        fontWeight={selected ? 'bold' : 'normal'}
      >
        {text}
      </Typography>
    </Button>
  );
};
